import SlsReporter from 'sls-wpk-reporter';
import wpkglobalerrorPlugin from 'sls-wpk-reporter/src/plugins/globalerror';
import wpkinterfacePlugin from 'sls-wpk-reporter/src/plugins/interface';
import wpkperformancePlugin from 'sls-wpk-reporter/src/plugins/performance';
import wpkflowPlugin from 'sls-wpk-reporter/src/plugins/flow';
import { PROJECT_ENV } from './config';
import { warn } from './logger';
const verifyCategory = (data) => {
    if (data && data.sdkCustomCategory) {
        return true;
    }
    if (data && data.category && data.category < 105) {
        warn('category 值小于 105，0-105 为系统预留。自定义 category 需要 105 及以上值');
        return false;
    }
    return true;
};
const wpkOptions = (opts) => {
    const { bid, project, endpoint, logstore, env, spa, debug, device_id, user_id, app_type, app_name, app_version } = opts;
    return {
        bid,
        project: project || PROJECT_ENV[env],
        endpoint: endpoint || 'cn-hangzhou.log.aliyuncs.com',
        logstore: logstore || 'sls-alysls-track-h5',
        slsParams: {
            sdk_version: '0.5.2',
            env,
            app_type,
            app_name,
            app_version,
            user_id
        },
        debug: !!debug,
        rel: '1.0.0',
        spa: !!spa,
        uid: device_id
    };
};
const errorPluginConfig = (opts) => {
    const { err_config, debug } = opts;
    const jsErrSampleRate = (err_config && err_config.js_sample_rate) || 1;
    const resErrSampleRate = (err_config && err_config.res_sample_rate) || 1;
    let config = {
        jsErr: true,
        resErr: true,
        jsErrSampleRate,
        resErrSampleRate,
        resErrFilter(err) {
            if (err && err.target) {
                const media = err.target || {};
                const isMedia = ['IMG', 'VIDEO', 'SOURCE', 'AUDIO', 'IFRAME', 'EMBED', 'SCRIPT'].includes(media.nodeName);
                if (isMedia && (!media.currentSrc || media.currentSrc === media.baseURI)) { // media.currentSrc === media.baseURI 适配safair
                    debug && warn('res errorFilter 资源异常不做上报', err);
                    return false;
                }
            }
            if (err_config && typeof err_config.res_filter === 'function') {
                return err_config.res_filter(err);
            }
            debug && warn('res error 资源异常', err);
            return err;
        }
    };
    if (err_config && err_config.js_filter) {
        config.jsErrFilter = err_config.js_filter;
    }
    return config;
};
const interfacePluginConfig = (opts) => {
    const { api_config, debug } = opts;
    return {
        enable: true,
        sampleRate: 1,
        withBody: true,
        errorFilter(params) {
            const url = params.url;
            if (api_config && api_config.whitelist && url) {
                for (let index = 0; index < api_config.whitelist.length; index++) {
                    const _url = api_config.whitelist[index];
                    if (url.includes(_url)) {
                        debug && warn('api fillter 该api请求不做上报', params);
                        return false;
                    }
                }
            }
            if (api_config && api_config.filter) {
                return api_config.filter(params);
            }
            return params;
        }
    };
};
export default class Reporter {
    constructor(opts) {
        opts.debug = opts.debug || window.location.search.includes('__reporter_debug=1');
        this.options = opts;
        const _wpkopts = wpkOptions(opts);
        this.wpk = new SlsReporter(Object.assign(Object.assign({}, _wpkopts), { plugins: [
                [
                    wpkflowPlugin,
                    {
                        enable: true // 是否开启站点流程监控。
                    }
                ],
                [
                    wpkperformancePlugin,
                    {
                        enable: true,
                        sampleRate: 0.1 // 性能数据的采样率。
                    }
                ],
                [
                    wpkglobalerrorPlugin,
                    errorPluginConfig(opts)
                ],
                [
                    wpkinterfacePlugin,
                    interfacePluginConfig(opts)
                ],
            ] }));
    }
    setOptions(opts) {
        const _wpkopts = wpkOptions(Object.assign(this.options, opts));
        this.wpk.setConfig(_wpkopts);
    }
    install() {
        this.wpk.install();
    }
    addPlugin(plugin, opts) {
        this.wpk.addPlugin(plugin, opts);
    }
    error(error, data) {
        if (!verifyCategory(data)) {
            return;
        }
        this.wpk.reportError(error, data);
    }
    api(data, extra) {
        if (!verifyCategory(data)) {
            return;
        }
        this.wpk.reportApi(data, extra);
    }
    info(data) {
        if (!verifyCategory(data)) {
            return;
        }
        this.wpk.report(data);
    }
}
